var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSankeyPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 165,
    viewBox: "0 0 226 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5252 42.8403H5V87H67.8705L112 65.5V16.5L54.5252 42.8403Z",
    fill: "#98A1AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.296 17.1385H114.834V40.8228H141.336L217.003 29.6459V2.50208L142.296 17.1385Z",
    fill: "#98A1AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.491 125.593H120.745V147.096H147.521L217.004 159.85V138.347L148.491 125.593Z",
    fill: "#98A1AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.532 40.8233H117.367V64.6286H172.379L217.003 64.6286V40.8233L168.532 40.8233Z",
    fill: "#98A1AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.654 102.949H119.056V126.174H174.534L219.537 126.174V102.949L170.654 102.949Z",
    fill: "#98A1AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4832 86.6908H9.28809V123.471H66.4832L115.679 147.656V103.122L66.4832 86.6908Z",
    fill: "#98A1AA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.489,
    y: 40.0602,
    width: 85.6325,
    height: 12.0186,
    rx: 5.80618,
    transform: "rotate(90 12.489 40.0602)",
    fill: "#373D43"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.031 97C118.237 97 120.837 99.5995 120.837 102.806L120.837 146.78C120.837 149.986 118.237 152.586 115.031 152.586L114.444 152.586C111.238 152.586 108.638 149.986 108.638 146.78L108.638 102.806C108.638 99.5995 111.238 97 114.444 97L115.031 97Z",
    fill: "#373D43"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.837,
    y: 13.0187,
    width: 55.586,
    height: 12.1989,
    rx: 5.80618,
    transform: "rotate(90 120.837 13.0187)",
    fill: "#373D43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 225.819,
    width: 30.0465,
    height: 12.0186,
    rx: 5.80618,
    transform: "rotate(90 225.819 0)",
    fill: "#373D43"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 37,
    width: 30.0465,
    height: 12.1989,
    rx: 5.80618,
    transform: "rotate(90 226 37)",
    fill: "#373D43"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 100,
    width: 30.0465,
    height: 12.1989,
    rx: 5.80618,
    transform: "rotate(90 226 100)",
    fill: "#373D43"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 134,
    width: 30.0465,
    height: 12.1989,
    rx: 5.80618,
    transform: "rotate(90 226 134)",
    fill: "#373D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSankeyPreview);
export default __webpack_public_path__ + "static/media/sankeyPreview.39cc5919c219bfe3e532b9f07cd3d062.svg";
export { ForwardRef as ReactComponent };